import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { GetSoundList, GlobalUrl, SoundUpdate, SoundAdd, SoundDelete,SosialAdd,SosialUpdate,GetSosialList } from '../db/db'
import { Form, Col, Row, Button, Modal, ProgressBar } from "react-bootstrap";
import { FaNewspaper, FaTrashAlt, FaWpforms,FaFacebook,FaTwitter,FaInstagram,FaSave } from 'react-icons/fa';
import { useAlert } from "react-alert";
const SosialMadia = (props) => {
    const QIssueIDData = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]
    const [QIssueID, setQIssueID] = useState(QIssueIDData)
    const [Face, setFace] = useState("facebook")
    const [Twit, setTwit] = useState()
    const [Inst, setInst] = useState()
    const [SosialData,setSosialData]=useState(null)
  
    useEffect( async () => {

        
       
        console.log("MagazineID", props.MagazineID)

        const SosialData = await GetSosialList(props.MagazineID).then((res) => {
            if (Array.from(res.sonuc).length>0){
            setFace(res.sonuc[0].facebookLink)
            setTwit(res.sonuc[0].twitterLink)
            setInst(res.sonuc[0].instagramLink)
                setSosialData("datavar")
        }
        console.log("faceee",Face)
            console.log("sonuccccccccc", Array.from(res.sonuc).length)
        })
    }, [])
    const myAlert = useAlert();
    return (
       
        <>
      
            <hr style={{ color: 'GrayText', size: "3" }} />
            <div style={{ textAlign: 'center', fontWeight: "bold" }}>Sosyal Medya Parametreleri</div>
            <hr style={{ color: 'GrayText', size: "3" }} />
            
            <Form.Group as={Row} className="mb-2">
                <Col >
            
                    <Form.Label column sm="12">
<FaFacebook/> Facebook Adresi
                    </Form.Label>
            
            </Col>
            <Col sm="12">
            <Form.Control value={Face} size="sm" type="text" placeholder="Facebook" onChange={(e)=>{
                setFace(e.target.value)
            }} />
            </Col>
                <Col >

                    <Form.Label column sm="12">
                        <FaTwitter /> Twitter Adresi
                    </Form.Label>

                </Col>
                <Col sm="12">
                    <Form.Control onChange={(e) => {
                        setTwit(e.target.value)
                    }} value={Twit} size="sm" type="text" placeholder="Twitter" />
                </Col>
                <Col >

                    <Form.Label column sm="12">
                        <FaInstagram /> Instagram Adresi
                    </Form.Label>

                </Col>
                <Col sm="12">
                    <Form.Control onChange={(e) => {
                        setInst(e.target.value)
                    }} value={Inst} size="sm" type="text" placeholder="Instagram" />
                </Col>
                <Form.Label column sm="12"></Form.Label>
                <Col sm="12">
                    <Button onClick={async()=>{
                        console.log("SosialVarYok",SosialData)
                        if (SosialData =="datavar"){
                            await SosialUpdate(QIssueID, 0, Face, Twit, Inst).then(() => {
                                myAlert.success("Sosyal Medya Linkleri Güncellendi")
                            })
                        }
                        else{
                            await SosialAdd(QIssueID, 0, Face, Twit, Inst).then(() => {
                                myAlert.success("Sosyal Medya Linkleri Eklendi")
                            })
                        }
                    }} className="btn-light" size="sm" active> <FaSave />  &nbsp; &nbsp; &nbsp; Kaydet</Button>
                </Col>
            </Form.Group>
           
        </>
    )
}

export default SosialMadia
